import { render } from "./setting-modal.vue?vue&type=template&id=48dfee09&scoped=true&ts=true"
import script from "./setting-modal.ts?vue&type=script&lang=ts&external"
export * from "./setting-modal.ts?vue&type=script&lang=ts&external"

import "./setting-modal.scss?vue&type=style&index=0&id=48dfee09&lang=scss&scoped=true&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48dfee09"]])

export default __exports__